import { ILogin } from "~/interfaces";
import { loadEvents } from "./events";
import { globalStore } from "~/stores/global";
import { savedStore } from "~/stores/saved";
import { loadCalendar } from "./google-calendar";
import Textures from "./textures";
import { getJwtCookie, removeJwtCookie, setJwtCookie } from "./jwt-cookie";
import { addNotification } from "~/stores/notifications";
import { getEventsLoadType } from "./php-api";

export const LOAD_EVENTS_ERROR = "Nepodařilo se načíst data stránky, zkuste to prosím znovu.";

// vraci false, pokud se nepodarilo nacist data -> uzivatel zustane neprihlaseny
export async function setUserData(data?: ILogin, removeCookie?: boolean): Promise<boolean> {
	const storeState = globalStore.getState();

	if (data) {
		// nastavime cookies
		setJwtCookie(data.jwt);
		// zalogujeme
		const savedState = savedStore.getState();
		const isMakuderovi = savedState.saved.service === "makuderovi";

		// textury
		Textures.load();

		try {
			// udalosti a kalendar na sobe nezavisi -> paralelne
			await Promise.all([
				loadEvents(savedState.saved.service, data),
				isMakuderovi && loadCalendar(data.isAdmin),
			]);
		} catch (exc) {
			/* eslint-disable-next-line */
			console.error(exc);
			// bez udalosti nelze web pouzivat -> neprihlaseny stav (cookie nechame, reload to zkusi znovu)
			storeState.setLogin(null);
			// spatny loadType - adminovi ukazeme chybu ze serveru
			addNotification(getEventsLoadType(data) ? exc.message : LOAD_EVENTS_ERROR, true);

			return false;
		}

		// nastaveni storu
		storeState.setLogin(data);

		const loadType = getEventsLoadType(data);

		if (loadType) {
			addNotification(`Načtené události skupiny „${loadType}“ (loadType)`);
		}

		if (isMakuderovi) {
			savedState.logVisit(data.permissions, data.isAdmin);
		} else {
			/* eslint-disable-next-line */
			console.log(`Skip log visit for everything except makuderovi`);
		}
	} else {
		storeState.setLogin(null);
		removeCookie && removeJwtCookie();
	}

	return true;
}

export function getJWTFromCookies() {
	return getJwtCookie();
}
